import { Modal } from "antd";
import React from "react";
import { $t } from "~/i18n.js";
import { BadgesPanel } from "./BadgesPanel.jsx";

export const BadgesModal = ({ open, onClose, badges = [] }) => {
  return (
    <Modal
      title={<span>{$t("Badges")}</span>}
      open={open}
      onCancel={onClose}
      width={720}
      footer={null}
      destroyOnClose
    >
      <BadgesPanel badges={badges} />
    </Modal>
  );
};
